

























import { mapGetters, mapState } from 'vuex';

import { getUserActiveHolds } from '@/api/Hold';

import { errorToastMessage } from '@/helpers/errorToastMessage';
import { getHoldGain, getHoldPeriod } from '@/helpers/holdHelpers';

export default {
  name: 'UserManagementActiveHoldsTab',
  props: {
    userId: {
      type: Number
    }
  },
  data(): any {
    return {
      isLoading: false,
      tableOptions: {
        page: 1,
        itemsPerPage: 10
      },
      tableItems: [],
      hasNext: false
    };
  },
  computed: {
    ...mapState('Auth', ['tokenSymbol']),
    ...mapGetters('Onboarding', ['operatorId']),
    itemsLength(): number {
      return (
        this.tableOptions.page * this.tableOptions.itemsPerPage +
        (this.hasNext ? 1 : 0)
      );
    },
    tableHeaders(): { [key: string]: string | boolean }[] {
      return [
        {
          text: 'Hold Date (UTC)',
          value: 'stakingDate',
          width: '150px',
          sortable: false
        },
        {
          text: 'Unhold Date (UTC)',
          value: 'unstakingDate',
          width: '150px',
          sortable: false
        },
        {
          text: 'Hold Amount',
          value: 'stakingAmount',
          sortable: false
        },
        {
          text: 'Period',
          value: 'period',
          sortable: false
        },
        {
          text: 'Gain',
          value: 'gain',
          sortable: false
        },
        {
          text: 'Reward Amount',
          value: 'rewardAmount',
          sortable: false
        }
      ];
    }
  },

  watch: {
    operatorId: {
      handler: 'fetchActiveHolds'
    }
  },

  methods: {
    getHoldGain,
    getHoldPeriod,
    async fetchActiveHolds(): Promise<void> {
      try {
        this.isLoading = true;

        const { content, last } = await getUserActiveHolds(this.userId, {
          size: this.tableOptions.itemsPerPage,
          page: this.tableOptions.page - 1
        });

        this.tableItems = content;
        this.hasNext = !last;
      } catch (error) {
        this.tableItems = [];
        this.hasNext = false;

        errorToastMessage(error);
      } finally {
        this.isLoading = false;
      }
    }
  }
};
